// extracted by mini-css-extract-plugin
export default {"itemDescription":"RenderItemDescription_itemDescription__QX+ny"};